/// <summary>
/// 驾驶地图信息 oyyh,20161008添加注释
/// </summary>
export class DriveMapInfo {

	constructor() {

		/// <summary>
		/// 中心点
		/// </summary>
		this.center = null;
		/// <summary>
		/// 地图比例尺
		/// </summary>
		this.scale = -1;
	}





	static GetDriveInfo(objProxy) {
		let mapInfo=null;
		if(objProxy==null)return mapInfo;
		mapInfo=new DriveMapInfo();
		mapInfo.center = objProxy.center;
		mapInfo.scale= objProxy.scale;
		return mapInfo;
	}

}//end DriveMapInfo

